import React from 'react';
import { Dropdown, Notifications } from '@bynder/design-system';
import { IconTime } from '@bynder/icons';
import { dispatchCustomEvent } from '../../helpers/useCustomEvent';

export function OutOfOfficeMenuItem() {
	function openModal() {
		dispatchCustomEvent('openOutOfOfficeModal');
	}

	return (
		<>
			<Dropdown.Item onClick={openModal} icon={<IconTime />}>
				Out of Office
			</Dropdown.Item>
			<Notifications />
		</>
	);
}
